import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIManager, Invoice, NotificationService, AFTER_INVOICE_PAID } from '@flashvpn-io/web-core';
import { interval, Subscription, takeWhile, timer } from 'rxjs';
import { AppConfigService } from '../../services/app-config.service';

@Component({
    selector: 'app-invoice-status',
    templateUrl: './invoice-status.component.html',
    styleUrls: ['./invoice-status.component.css']
})
export class InvoiceStatus implements OnInit, OnDestroy {
    invoiceId: string | null = null;
    status: string = 'Unpaid';
    payImageUrl = 'assets/images/pay.png';
    private checkSubscription: Subscription | null = null;
    private readonly CHECK_INTERVAL = 5000; // 5 sec
    private readonly TIMEOUT = 120000; // 2 min
    private isExtension = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private apiManager: APIManager,
        private appConfigService: AppConfigService,
        private notificationService: NotificationService,
    ) {
        this.isExtension = this.appConfigService.getBuildTarget() === 'extension';
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.invoiceId = params['invoiceId'] || null;
            if (!this.invoiceId) {
                return;
            }
            this.checkInvoiceStatus(); // 立即检查一次
            this.startCheckingStatus();
        });
    }

    private checkInvoiceStatus(): void {
        this.apiManager.fetchInvoiceDetail(+this.invoiceId!)
            .subscribe({
                next: (invoice: Invoice) => {
                    if (invoice.status === 'Paid') {
                        if (this.status === 'Unpaid') {
                            this.notificationService.post(AFTER_INVOICE_PAID, {});
                        }
                        this.status = 'Paid';
                        this.stopChecking();
                    }
                },
                error: (error) => {
                    console.error('Error fetching invoice:', error);
                    this.status = 'Failed';
                    this.stopChecking();
                }
            });
    }

    private startCheckingStatus(): void {
        timer(this.TIMEOUT).subscribe(() => {
            this.status = 'Failed';
            this.stopChecking();
        });

        this.checkSubscription = interval(this.CHECK_INTERVAL)
            .pipe(
                takeWhile(() => this.status === 'Unpaid')
            )
            .subscribe(() => {
                this.checkInvoiceStatus();
            });
    }

    private stopChecking(): void {
        if (this.checkSubscription) {
            this.checkSubscription.unsubscribe();
            this.checkSubscription = null;
        }
    }

    ngOnDestroy(): void {
        this.stopChecking();
    }

    goToService() {
        if (this.isExtension) {
            this.router.navigate(['/services/dashboard']);
        } else {
            this.router.navigate(['/home']);
        }
    }
} 